export var UNKNOWN = 'Unknown';
export var UNKNOWN_USER = {
  id: UNKNOWN,
  name: UNKNOWN,
  type: 'user'
};
export var UNKNOWN_TEAM = {
  id: UNKNOWN,
  name: UNKNOWN,
  type: 'team'
};